/* eslint-disable import/prefer-default-export */
export const TERMS_AND_CONDITIONS_TITLE = [
  { text: 'Términos y Condiciones', color: 'secondary', variant: 'body2', letterSpacing: 0 },
];
